import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Autocomplete with remote loading and create option
export default class extends Controller {
  static targets = ["select", "componentId", "componentName", "categoryWrapper"]
  static values = { url: String }

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      maxItems: 1,
      create: true,
      createFilter: (input) => input.length >= 2,
      load: (query, callback) => {
        if (query.length < 2) return callback([])

        fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(data => callback(data))
          .catch(() => callback([]))
      },
      render: {
        option: (data, escape) => {
          if (data.category) {
            return `<div class="flex justify-between items-center">
              <span>${escape(data.text)}</span>
              <span class="text-xs text-text-muted">${escape(data.category)}</span>
            </div>`
          }
          return `<div>${escape(data.text)}</div>`
        },
        item: (data, escape) => {
          return `<div>${escape(data.text)}</div>`
        },
        option_create: (data, escape) => {
          return `<div class="create">Add <strong>${escape(data.input)}</strong> as custom component...</div>`
        },
        no_results: () => {
          return `<div class="no-results p-2">No components found. Type to add a custom one.</div>`
        }
      },
      onItemAdd: (value, item) => {
        this.handleSelection(value)
      },
      onClear: () => {
        this.clearSelection()
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  handleSelection(value) {
    const isCustom = !this.tomSelect.options[value]?.category

    if (isCustom || isNaN(parseInt(value))) {
      this.componentIdTarget.value = ""
      this.componentNameTarget.value = value
      this.showCategorySelect()
    } else {
      this.componentIdTarget.value = value
      this.componentNameTarget.value = ""
      this.hideCategorySelect()
    }

    this.appendEmptyRowIfLast()
  }

  appendEmptyRowIfLast() {
    const wrapper = this.element.closest(".nested-form-wrapper")
    if (!wrapper) return

    const section = wrapper.closest("[data-controller~='nested-form']")
    if (!section) return

    const wrappers = section.querySelectorAll(".nested-form-wrapper")
    if (wrappers[wrappers.length - 1] !== wrapper) return

    const addButton = section.querySelector("[data-action~='nested-form#add']")
    if (addButton) addButton.click()
  }

  clearSelection() {
    this.componentIdTarget.value = ""
    this.componentNameTarget.value = ""
    this.hideCategorySelect()
  }

  showCategorySelect() {
    if (this.hasCategoryWrapperTarget) {
      this.categoryWrapperTarget.classList.remove("hidden")
    }
  }

  hideCategorySelect() {
    if (this.hasCategoryWrapperTarget) {
      this.categoryWrapperTarget.classList.add("hidden")
    }
  }
}
